import { ServiceTools } from "src/entities";

export const ServiceToolsPage = () => {
  return <ServiceTools />;
};
